import { render, staticRenderFns } from "./Sale-card-home.vue?vue&type=template&id=2980365c&scoped=true"
import script from "./Sale-card-home.vue?vue&type=script&lang=js"
export * from "./Sale-card-home.vue?vue&type=script&lang=js"
import style0 from "./Sale-card-home.vue?vue&type=style&index=0&id=2980365c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2980365c",
  null
  
)

export default component.exports